(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class GvStickyAtc {
    constructor() {
      this.el = document.querySelector('[data-sticky-add-to-cart]');
      if (!this.el) return;

      this.buttons = Array.from(this.el.querySelectorAll('[data-sticky-add-to-cart-button]'));
      this.mainButton = this.findMainButton();
      this.destroyed = false;
      this.intervals = [];

      this.scrollPercent = parseFloat(this.el.dataset.scrollPercent);
      if (isNaN(this.scrollPercent)) this.scrollPercent = 15;

      this.hideAtPercent = 95;

      this.init();
    }

    destroy() {
      this.destroyed = true;
      this.intervals.forEach((id) => clearInterval(id));
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onVariant) document.removeEventListener('variant:update', this._onVariant);
    }

    findMainButton() {
      const selectors = [
        '.buy-buttons-block .add-to-cart-button',
        '[data-testid="standalone-add-to-cart"]',
        'button[ref="addToCartButton"]',
        'product-form-component .add-to-cart-button',
        'form[data-type="add-to-cart-form"] button[type="submit"]',
        '.product-form button[type="submit"]',
        '.add-to-cart-button',
        'button[name="add"]'
      ];
      for (const s of selectors) {
        const b = document.querySelector(s);
        if (b) return b;
      }
      return null;
    }

    init() {
      this.setupClick();
      this.setupScroll();
      this.setupVariantImage();
      this.updateVisibility();

      const rescan = setInterval(() => {
        if (this.destroyed) return;
        const b = this.findMainButton();
        if (b !== this.mainButton) this.mainButton = b;
      }, 2000);
      this.intervals.push(rescan);
    }

    setupClick() {
      this.el.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sticky-add-to-cart-button]');
        if (!btn) return;
        // Never submit / add to cart: only scroll to the real ATC.
        e.preventDefault();
        e.stopPropagation();
        this.scrollToMain();
      });
    }

    scrollTarget() {
      if (this.mainButton) {
        return (
          this.mainButton.closest(
            '.buy-buttons-block, product-form-component, .product-form, form[data-type="add-to-cart-form"]'
          ) || this.mainButton
        );
      }
      const sels = [
        '.buy-buttons-block',
        'product-form-component',
        '.product-form',
        'form[data-type="add-to-cart-form"]',
        'variant-picker'
      ];
      for (const s of sels) {
        const el = document.querySelector(s);
        if (el) return el;
      }
      return null;
    }

    scrollToMain() {
      const target = this.scrollTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setupVariantImage() {
      this._onVariant = (e) => {
        const variant = e.detail && e.detail.resource;
        if (variant) this.updateThumb(variant);
      };
      document.addEventListener('variant:update', this._onVariant);
    }

    updateThumb(variant) {
      const img = this.el.querySelector('[data-sticky-thumb] img');
      if (!img || !variant || !variant.featured_media) return;
      const media = variant.featured_media;
      let base = (media.preview_image && media.preview_image.src) || media.src || null;
      if (!base) return;
      base = base.split('?')[0];
      img.src = base + '?width=160';
      if (media.alt) img.alt = media.alt;
    }

    updateVisibility() {
      if (this.destroyed || !document.contains(this.el)) return;
      const winHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const scrollable = Math.max(docHeight - winHeight, 1);
      const percent = (window.scrollY / scrollable) * 100;
      const visible = percent >= this.scrollPercent && percent < this.hideAtPercent;
      this.el.classList.toggle('is-visible', visible);
    }

    setupScroll() {
      let ticking = false;
      this._onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.updateVisibility();
            ticking = false;
          });
          ticking = true;
        }
      };
      this._onResize = this._onScroll;
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
    }
  }

  window.GvStickyAtc = GvStickyAtc;

  function initGvStickyAtc() {
    if (window.gvStickyAtcInstance) window.gvStickyAtcInstance.destroy();
    window.gvStickyAtcInstance = new GvStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGvStickyAtc);
  } else {
    initGvStickyAtc();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-sticky-add-to-cart]')) {
      initGvStickyAtc();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
